import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UirouterMigrationService } from 'Utilities/uirouter.migration.service';
import { ChainService } from './chain.service';
import { FormControl } from '@angular/forms';
import { debounceTime, finalize } from 'rxjs/operators';

@Component({
  selector: 'app-chains',
  template: require('./chains.component.html'),
})

/** @desc Container component to handle chains **/
export class ChainsComponent implements OnInit {
  isLoading = false;
  chains: number;
  chainsTotal: number;
  paginationMaxSize = 5;
  itemsPerPage = this.chainService.PAGINATION_LIMIT;
  currentPage = 1;
  searchControl: FormControl;

  constructor(private uirouterMigrationService: UirouterMigrationService, private chainService: ChainService, private cd: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.addSearchElement();
    this.getChains();
  }

  /**
   * @desc Helper to handle create new chain button click instead of using ui-router
   * @return {void}
   */
  handleLink(state: string, params?: any): void {
    this.uirouterMigrationService.goTo(state, params);
  }

  addSearchElement() {
    this.searchControl = new FormControl();
    this.searchControl.valueChanges.pipe(debounceTime(500)).subscribe(newValue => this.getChains(1, newValue));
  }

  /**
   * @desc Function to retrieve chains according to filters
   * @param {number} page - Optional page number parameter
   * @return {void}
   */
  getChains(page?: number, query: string = ''): void {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.chainService
      .getChains(page || this.currentPage, query)
      .pipe(finalize(() => {
        this.isLoading = false;
      }))
      .subscribe(data => {
        if (data) {
          this.chains = data.chains;
          this.chainsTotal = data.total;
          this.cd.detectChanges();
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/chains/chains.component.ts